module.exports = __webpack_public_path__ + "static/media/answerPIC13.7991d3fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerPIC13.png
// module id = 1720
// module chunks = 0 1